module.exports = "<p style=\"vertical-align: center; text-align: center;\">Hi, nice to see you here!</p>\r\n"